import { CLOSE_TRIM_VIDEO_MODAL, SHOW_TRIM_VIDEO_MODAL } from './types';

export const showTrimVideoModal = () => ({
  type: SHOW_TRIM_VIDEO_MODAL,
});

export const closeTrimVideoModal = () => ({
  type: CLOSE_TRIM_VIDEO_MODAL,
});
